import {ApiTags} from '@nestjs/swagger';
import { Controller, Post, Body, Req } from '@nestjs/common';
import {ApplicationExceptionHandler} from '@gtpl/shared-utils/error-messages';
import { CommonResponse } from '@gtpl/shared-models/masters';
import { BlanchingCookingAdapter } from '../dto/blanching-cooking.adapter';
import { BlanchingCookingDTO } from '../dto/blanching-cooking.dto';
import { BlanchingCooking } from '../entities/blanching-cooking.entity';
import { BlanchingCookingService } from './blanching-cooking.service';
import { AllBlanchingCookingReponseModel, BlanchingCookingDto, BlanchingCookingReponseModel, LogIdRequest } from '@gtpl/shared-models/production-management';

@ApiTags('Blanching-cooking')
@Controller('blanching-cooking')
export class BlanchingCookingController {
    constructor(
        private service: BlanchingCookingService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler
    ){}
    @Post('/createBlanchingCooking')
    async createBlanchingCooking(@Body() dto: BlanchingCookingDTO, isUpdate: boolean = false): Promise<BlanchingCookingReponseModel>{
    try{
        return await this.service.createBlanchingCooking(dto, false);        
         } catch(error){
             return this.applicationExceptionHandler.returnException(BlanchingCookingReponseModel, error);
        }
    } 

    @Post('/getSamplleInfoByLogId')
    async getSamplleInfoByLogId(@Body()jobNumber : LogIdRequest): Promise<AllBlanchingCookingReponseModel> {
        try {
            return await this.service.getSamplleInfoByLogId(jobNumber)
        } catch (error) {
            return this.applicationExceptionHandler.returnException(AllBlanchingCookingReponseModel, error);
        }
    }
}
